var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cr-menu",style:(_vm.cssVars)},[_vm._t("activator",null,{"on":_vm.toggle}),_c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"cr-menu__dropdown"},[_vm._t("default")],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }